import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./theme.css";

const storedTheme = (() => {
  try { return localStorage.getItem("placement:theme") || "ivory"; } catch { return "ivory"; }
})();
document.documentElement.dataset.theme = storedTheme;

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
